import React from "react";
import {
	AirportIcon,
	CentralWarehouseIcon,
	CommercialWarehouseIcon,
	CustomerIcon,
	GDORetailDistributionCenterIcon,
	IndustrialCopackerIcon,
	IndustrialWarehouseIcon,
	InterportRailwayNodeIcon,
	OfficeIcon,
	PeripheralWarehouseIcon,
	PlantIcon,
	PlantWarehouseIcon,
	RawMaterialPackagingIcon,
	SeaportIcon,
	TransitPointIcon,
} from "../assets/icons";

const NODE_TYPE_ICON_MAP: Record<number, React.ElementType> = {
	1: PlantWarehouseIcon,
	2: CentralWarehouseIcon,
	3: PeripheralWarehouseIcon,
	4: TransitPointIcon,
	5: InterportRailwayNodeIcon,
	6: SeaportIcon,
	7: AirportIcon,
	8: GDORetailDistributionCenterIcon,
	9: CustomerIcon,
	10: PlantIcon,
	11: OfficeIcon,
	12: CommercialWarehouseIcon,
	13: IndustrialWarehouseIcon,
	14: IndustrialCopackerIcon,
	15: RawMaterialPackagingIcon,
};

export const getNodeTypeIcon = (typeId?: number | null) => {
	if (typeId && NODE_TYPE_ICON_MAP[typeId]) {
		return NODE_TYPE_ICON_MAP[typeId];
	}
	return undefined;
};
